var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.5,
    viewBox: "0 0 18 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_upload_filled",
    "data-name": "UI icon/upload/filled",
    transform: "translate(-3 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10.705,4.791A1,1,0,0,1,9.291,6.205L6.5,3.414V10.5a1,1,0,0,1-2,0V3.414L1.707,6.207A1,1,0,0,1,.293,4.793l4.5-4.5a1,1,0,0,1,1.414,0Z",
    transform: "translate(6.502 4.5)",
    fill: "#356ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13_Copy_7_Stroke_",
    "data-name": "Path 13 Copy 7 (Stroke)",
    d: "M1,0A1,1,0,0,1,2,1V3A1,1,0,0,0,3,4H15a1,1,0,0,0,1-1V1a1,1,0,0,1,2,0V3a3,3,0,0,1-3,3H3A3,3,0,0,1,0,3V1A1,1,0,0,1,1,0Z",
    transform: "translate(3 14)",
    fill: "#356ab3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadButton);
export default __webpack_public_path__ + "static/media/uploadButton.fe51c5143fbd8ce279eecc3f039151cc.svg";
export { ForwardRef as ReactComponent };